import script from "./ImageAdminPageNoAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageAdminPageNoAuth.vue?vue&type=script&setup=true&lang=js"

import "./ImageAdminPageNoAuth.vue?vue&type=style&index=0&id=4b48303c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b48303c"]])

export default __exports__